import React from "react";
import Seo, { breadcrumbSchema } from "../components/Seo";
import { LegalShell, H2, P, UL } from "./PrivacyPolicy";
import { SITE } from "../data/mock";

export default function TermsOfUse() {
  const crumbs = [
    { name: "Home", path: "/" },
    { name: "Terms of Use", path: "/terms-of-use" },
  ];
  return (
    <>
      <Seo
        title="Terms of Use | Boston Iron Grit"
        description="The terms that govern use of the Boston Iron Grit website, class bookings, memberships and content — including health disclaimers and liability."
        path="/terms-of-use"
        schemas={[breadcrumbSchema(crumbs)]}
      />
      <LegalShell title="Terms of Use" updated="August 12, 2026" crumbName="Terms of Use" path="/terms-of-use">
        <div>
          <H2>Agreement</H2>
          <P>
            By using bostonirongrittraining.com you agree to these terms. The website is operated by Boston Iron Grit,
            {" "}{SITE.address.full}. If you do not agree, please do not use the site.
          </P>
        </div>
        <div>
          <H2>Not medical advice</H2>
          <P>
            Content on this site — including blog articles, program descriptions and information about labs, supplements, peptides and
            GLP-1 medications — is provided for general information only and is not medical advice. Always consult a qualified healthcare
            professional before beginning any exercise or nutrition program, or making any medical decision. Medical services referenced on
            this site are provided by independent licensed providers who determine eligibility and supervise treatment.
          </P>
        </div>
        <div>
          <H2>Assumption of risk</H2>
          <P>
            Physical training involves inherent risk. Participation in classes, open gym, personal training and events requires a signed
            waiver and is subject to the membership agreement provided at the gym. Website content does not replace in-person coaching.
          </P>
        </div>
        <div>
          <H2>Memberships, bookings and payments</H2>
          <UL
            items={[
              "Class reservations and purchases are processed through ChalkIt Pro, our booking platform, under its own terms.",
              "Memberships are month-to-month unless otherwise stated. Punch cards carry the expiration listed at purchase.",
              "Membership holds and cancellations can be requested through the member services forms on this site and take effect per your membership agreement.",
              "Prices on this site are current as of the last update and may change; the price at checkout governs.",
            ]}
          />
        </div>
        <div>
          <H2>Intellectual property</H2>
          <P>
            The Boston Iron Grit name, logo, Live B.I.G. 365 program materials and site content are our property or used with permission.
            You may not reproduce them commercially without written consent.
          </P>
        </div>
        <div>
          <H2>Limitation of liability</H2>
          <P>
            The website is provided "as is." To the fullest extent permitted by law, Boston Iron Grit is not liable for indirect or
            consequential damages arising from use of the site. Nothing in these terms limits liability that cannot be limited by law.
          </P>
        </div>
        <div>
          <H2>Contact</H2>
          <P>Questions about these terms: {SITE.email} or {SITE.phone}.</P>
        </div>
      </LegalShell>
    </>
  );
}
